import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { UserEndpoint } from '../constants/user-endpoint';
import { UserBrief, UserListSearchCriteria, UserRolesModel } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ProfileModel } from '../../profile';
import { Role } from '../../../../../common/constants';

@Injectable({
  providedIn: 'root',
})
export class UserListService {
  private readonly storageKey = 'mor-assigned-roles';
  masterOfRolesAssignedRoles: Role[] | UserRolesModel = [];

  constructor(private http: WrapperHttpService) {}

  setMoRAssingedRolesFromProfile(): void {
    this.http
      .withLoading()
      .get<ProfileModel>(`${API_URL}${UserEndpoint.Profile}`)
      .pipe()
      .subscribe((data: ProfileModel) => {
        this.setMasterofRolesAssignedRoles(data.masterOfRolesAssignedRoles);
      });
  }

  getMasterofRolesAssignedRoles(): UserRolesModel {
    const masterOfRolesAssignedRolesJson = localStorage.getItem(this.storageKey);
    return JSON.parse(masterOfRolesAssignedRolesJson);
  }

  setMasterofRolesAssignedRoles(masterOfRolesAssignedRoles: Role[] | UserRolesModel): void {
    const masterOfRolesAssignedRolesJson = JSON.stringify(masterOfRolesAssignedRoles);
    localStorage.setItem(this.storageKey, masterOfRolesAssignedRolesJson);
  }

  getUserList({ size, page, ...filterView }: UserListSearchCriteria): Observable<UserBrief[]> {
    const url = `${API_URL}${UserEndpoint.Base}${UserEndpoint.Search}?${getQueryStringFromObject({
      page,
      size,
    })}`;
    this.setMoRAssingedRolesFromProfile();
    return this.http.withLoading().post<UserBrief[]>(url, filterView);
  }

  downloadUserList(body: { name: string; filterView: Partial<UserListSearchCriteria> }): Observable<void> {
    const url = `${API_URL}${UserEndpoint.Exports}${UserEndpoint.Base}` + '?name=' + body.name;
    return this.http.withLoading().post<void>(url, body.filterView);
  }
}
